import React, { useMemo } from 'react';
import { Image } from 'src/components';
import defaultClasses from './selectOptions.module.css';
import { generateUrl } from '@magento/peregrine/lib/util/imageUtils';
var SWATCH_WIDTH = 112;

var SelectOptionsItem = function SelectOptionsItem(_ref) {
  var option = _ref.option,
      label = _ref.label;
  var selectImageUrl = useMemo(function () {
    var _option$swatch_data, _option$swatch_data2;

    if (option !== null && option !== void 0 && (_option$swatch_data = option.swatch_data) !== null && _option$swatch_data !== void 0 && _option$swatch_data.value) {
      return generateUrl(option.swatch_data.value, 'image-swatch')(SWATCH_WIDTH);
    } else if (option !== null && option !== void 0 && (_option$swatch_data2 = option.swatch_data) !== null && _option$swatch_data2 !== void 0 && _option$swatch_data2.thumbnail) {
      return option.swatch_data.thumbnail;
    } else {
      return '';
    }
  }, [option]);
  return React.createElement("div", {
    className: "bg-snowbound grid grid-cols-12 items-center"
  }, React.createElement("div", {
    className: defaultClasses.selectOptionsImage + ' col-span-5'
  }, React.createElement("img", {
    src: selectImageUrl,
    alt: option === null || option === void 0 ? void 0 : option.store_label
  })), React.createElement("div", {
    className: "ml-5 col-span-7 justify-self-start"
  }, label ? React.createElement("h6", {
    className: "text-black font-bold"
  }, label) : React.createElement(React.Fragment, null), React.createElement("p", {
    className: "text-bronze text-base"
  }, option.store_label)));
};

export default SelectOptionsItem;